import styled from "styled-components";

const HeaderStyled = styled.div`
    background-color: ${props => props.theme.lightGray};

    .header {
        &__container {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 2.4rem 1.6rem;
            position: relative;

            @media only screen and (min-width: ${props => props.theme.tablet}) {
                max-width: 1200px;
                padding: 1.6rem 4.8rem 2.4rem;
            }
        }

        &__title {
            display: flex;
            min-width: 20rem;
            flex-direction: column;

            h1 {
              &, span {
                font-size: 2.6rem;
                margin-bottom: 0.5rem;
                line-height: 4.2rem;
              }
            }
        }

        .business__title {
            font-family: ${props => props.theme.fontRegular};
            font-size: 1.8rem;
            color: ${props => props.theme.darkGreen};
        }
    }
`;

const NavigationStyled = styled.div`
    nav {
        font-size: 1.6rem;
        line-height: 2rem;
        padding: 0.4rem;
        color: ${props => props.theme.darkerGreen};
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .header__utility__nav--list {
            padding: 0;
        }

        button,
        a:not(.card-link) {
            position: relative;
            display: flex;
            align-items: center;
            color: ${props => props.theme.darkerGreen};
            text-decoration: none;
            padding: 0.8rem 0.4rem;
            margin-right: 1.2rem;
            margin-left: 1.2rem;
            font-weight: bold;
            font-size: 1.5rem;
            font-family: ${props => props.theme.fontBold};
            cursor: pointer;

            &:not(.submenu-dropdown):not(.header__basket a):not(.search-icon):not(.m59__logout a) {
                &:after {
                    width: 0;
                    height: 0.2rem;
                    content: "";
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    margin: auto;
                    transition: width 0.5s ease;
                    background-color: ${props => props.theme.darkerGreen};
                }

                &:hover {
                    &:after {
                        width: 100%;
                    }
                }
            }

            &.submenu-dropdown {
                &:after {
                    content: "";
                    width: 1.2rem;
                    height: 1.2rem;
                    background-image: url("data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2210px%22%20height%3D%226px%22%20viewBox%3D%220%200%2010%206%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%2058%20%2884663%29%20-%20https%3A%2F%2Fsketch.com%20--%3E%0A%20%20%20%20%3Ctitle%3EMask%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cg%20id%3D%22Page-1%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Advantage%2FUsermenu%22%20transform%3D%22translate%28-101.000000%2C%20-12.000000%29%22%20fill%3D%22%23444444%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Profile-page%2FUsermenu%22%20transform%3D%22translate%285.000000%2C%200.000000%29%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M100.999983%2C18%20C100.820763%2C18%20100.641565%2C17.9279717%20100.504925%2C17.784218%20L96.2051418%2C13.2583168%20C95.9316194%2C12.9704134%2095.9316194%2C12.5036272%2096.2051418%2C12.2158402%20C96.4785535%2C11.9280533%2096.9219347%2C11.9280533%2097.1954792%2C12.2158402%20L100.999983%2C16.220608%20L104.80451%2C12.21598%20C105.078032%2C11.928193%20105.521369%2C11.928193%20105.794759%2C12.21598%20C106.068414%2C12.503767%20106.068414%2C12.9705531%20105.794759%2C13.2584566%20L101.495041%2C17.7843578%20C101.358336%2C17.9281348%20101.179137%2C18%20100.999983%2C18%20Z%22%20id%3D%22Mask%22%20transform%3D%22translate%28101.000000%2C%2015.000000%29%20scale%28-1%2C%20-1%29%20rotate%28-180.000000%29%20translate%28-101.000000%2C%20-15.000000%29%20%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E");
                    background-repeat: no-repeat;
                    background-position-y: 50%;
                    background-position-x: 50%;
                    visibility: visible;
                    display: inline-block;
                    vertical-align: middle;
                    margin-left: 0.6rem;
                }

                &.basket {
                    margin-top: 0.2rem;

                    &:after {
                        display: none;
                    }

                    .basket-count {
                        pointer-events: none;
                    }

                    img {
                        pointer-events: none;
                    }

                    & + ul {
                        .childmenu-item {
                            &:hover {
                                &:before {
                                    content: "|";
                                    position: absolute;
                                    left: -1.6rem;
                                    top: 1.2rem;
                                    line-height: 0;
                                    font-size: 1.6rem;
                                }
                            }
                        }
                    }
                }
            }


            &.header__utility-search {
                margin-right: 0;
                margin-top: 0.2rem;
            }
        }
        
        .user-menu-wrapper {
            position: relative;
        }

        .user-menu-list {
            opacity: 0;
            visibility: hidden;

            &.expanded {
                opacity: 1;
                visibility: visible;
            }
        }

        .m59--myap.dropdown {
            margin-left: 0;
        }

        .m59__list.user {
            width: 30rem;
            padding: 2rem 3rem;
            background-color: ${props => props.theme.white};
            border-radius: 0.5rem;
            position: absolute;
            top: 3rem;
            right: 0;
            z-index: 200;
            box-shadow: 0 0 10px 0 rgb(61 69 67 / 20%);
            overflow: auto;
            display: flex;
            flex-direction: column;

            li:not(.m59__logout) {
                margin: 0.8rem 0;
                position: relative;

                a {
                    margin: 0;
                    color: ${props => props.theme.black};
                    font-size: 1.3rem;
                    font-weight: 900;
                    padding: 0;

                    &.active {
                        color: ${props => props.theme.green};

                        &:before {
                            content: "|";
                            position: absolute;
                            left: -2rem;
                            top: 50%;
                            -ms-transform: translateY(-50%);
                            transform: translateY(-50%);
                            line-height: 0;
                            cursor: auto;
                        }
                    }

                    &:hover {
                        color: ${props => props.theme.green} !important;
                    }

                    &:hover:not(.active) {
                        &:before {
                            display: none;
                        }
                    }
                }
            }
        }

        .m59__logout {
            margin: 1rem 0 0;
		
            a {
                display: block;
                margin: 0;
                color: #1b1e1c;
                font-size: 1.5rem;
                font-weight: 900;
                color: ${props => props.theme.heritageGreen};
                position: relative;
                border-top: 1px solid ${props => props.theme.lightGray5};
                padding: 1.5rem 0 0;

                &:after {
                    content: "";
                    display: inline-block;
                    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 14 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M7.29289 0.292893C7.68342 -0.0976311 8.31658 -0.0976311 8.70711 0.292893L13.7071 5.29289C14.0976 5.68342 14.0976 6.31658 13.7071 6.70711L8.70711 11.7071C8.31658 12.0976 7.68342 12.0976 7.29289 11.7071C6.90237 11.3166 6.90237 10.6834 7.29289 10.2929L10.5858 7H1C0.447715 7 0 6.55228 0 6C0 5.44772 0.447715 5 1 5H10.5858L7.29289 1.70711C6.90237 1.31658 6.90237 0.683417 7.29289 0.292893Z' fill='%23008755'/%3E%3C/svg%3E");
                    background-repeat: no-repeat;
                    height: 1rem;
                    width: 1.4rem;
                    margin-left: 0.8rem;
                }

                &:hover {
                    cursor: pointer;
                    color: ${props => props.theme.black};

                    &:before {
                        display: none;
                    }
                }
            }
        }

        .header__basket {
            margin-right: 0;
            text-align: left;
        }

        .basket-count {
            position: absolute;
            color: ${props => props.theme.white};
            background-color: ${props => props.theme.red};
            min-width: 2.1rem;
            height: 2.1rem;
            border-radius: 50%;
            top: -0.2rem;
            right: -0.8rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.2rem;
            line-height: 2rem;
            font-family: ${props => props.font};
            font-weight: 400;
        }

        .m58__modal {
            top: 3rem;
            right: 0;
        }
    }
`

export { HeaderStyled, NavigationStyled };
